import { __extends, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Component, Vue } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import 'reflect-metadata';
import { LinkVariant } from './LinkVariant.js';

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=1705%3A4969
 * @storybook /?path=/story/typography-link--playground
 * @react /src-components-link
 * @reactStorybook /?path=/story/typography-link--playground
 */
var HseLink = /** @class */ (function (_super) {
    __extends(HseLink, _super);
    function HseLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HseLink.prototype.handleClick = function (e) {
        if (this.inactive)
            e.preventDefault();
        /**
         * Событие клика на ссылку
         * @type {MouseEvent}
         */
        this.$emit('click', e);
    };
    Object.defineProperty(HseLink.prototype, "inactiveAttrs", {
        get: function () {
            return this.inactive ? {
                tabindex: -1,
                role: 'button',
                'aria-disabled': true
            } : {};
        },
        enumerable: false,
        configurable: true
    });
    HseLink.prototype.showWarnings = function () {
        if (this.variant === LinkVariant.primary && this.underlined) {
            console.warn('Использование primary варианта и свойства underlined не поддерживается');
        }
    };
    HseLink.prototype.mounted = function () {
        this.showWarnings();
    };
    HseLink.prototype.updated = function () {
        this.showWarnings();
    };
    Object.defineProperty(HseLink.prototype, "listeners", {
        get: function () {
            return __assign(__assign({}, this.$listeners), { click: this.handleClick });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({
            default: 'a'
        }),
        __metadata("design:type", Object)
    ], HseLink.prototype, "component", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseLink.prototype, "inactive", void 0);
    __decorate([
        Prop(EnumProp(LinkVariant.primary, LinkVariant)),
        __metadata("design:type", String)
    ], HseLink.prototype, "variant", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseLink.prototype, "underlined", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseLink.prototype, "showVisited", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseLink.prototype, "standalone", void 0);
    HseLink = __decorate([
        Component({
            name: 'HseLink'
        })
    ], HseLink);
    return HseLink;
}(Vue));

export default HseLink;
